import React, { useState } from 'react';
import { useAuth } from '../hooks/useAuth';
import AuthErrorMessage from './AuthErrorMessage';
import './GoogleSignInButton.css';
import './AuthErrorMessage.css';

interface GoogleSignInButtonProps {
  disabled?: boolean;
  className?: string;
  text?: string;
  userType?: 'user' | 'organization';
}

/**
 * Bouton de connexion avec Google
 */
const GoogleSignInButton: React.FC<GoogleSignInButtonProps> = ({
  disabled = false,
  className = '',
  text = 'Continuer avec Google',
  userType = 'user'
}) => {
  const { loginWithGoogle, error, resetAuthError } = useAuth();
  const [loading, setLoading] = useState(false);
  const [localError, setLocalError] = useState<string | null>(null);
  const [errorCode, setErrorCode] = useState<string | undefined>(undefined);

  const handleSignIn = async () => {
    try {
      // Réinitialiser les erreurs
      resetAuthError();
      setLocalError(null);
      setErrorCode(undefined);
      
      // Enregistrer l'état de départ pour le débogage
      console.log(`🔷 Démarrage connexion Google (userType: ${userType})`, new Date().toISOString());
      setLoading(true);
      
      // Stocker le type d'utilisateur dans sessionStorage pour l'inscription
      sessionStorage.setItem('googleSignUpUserType', userType);
      
      // Déclencher la redirection de connexion Google
      await loginWithGoogle();
      
      // Note: Ce code ne s'exécutera pas en raison de la redirection
      console.log("🔷 Ce message ne devrait jamais s'afficher");
    } catch (error: any) {
      console.error('🔴 Erreur connexion Google:', error);
      
      // Capturer à la fois le message et le code d'erreur
      setLocalError(error.message || 'Erreur connexion Google');
      
      // Extraire le code d'erreur pour suggestions adaptées
      if (error.code) {
        console.log('Code d\'erreur d\'authentification Google:', error.code);
        setErrorCode(error.code);
      }
      
      // Nettoyer le type d'utilisateur en cas d'erreur
      sessionStorage.removeItem('googleSignUpUserType');
      
      setLoading(false);
    }
  };

  // Utiliser l'erreur du contexte d'authentification ou l'erreur locale
  const errorMessage = error?.message || localError;

  return (
    <div className="google-signin-container">
      <button 
        onClick={handleSignIn} 
        className={`google-signin-button ${className}`} 
        disabled={loading || disabled}
        data-testid="google-signin-button"
      >
        <svg viewBox="0 0 24 24" className="google-icon">
          <path d="M12.24 10.285V14.4h6.806c-.275 1.765-2.056 5.174-6.806 5.174-4.095 0-7.439-3.389-7.439-7.574s3.345-7.574 7.439-7.574c2.33 0 3.891.989 4.785 1.849l3.254-3.138C18.189 1.186 15.479 0 12.24 0c-6.635 0-12 5.365-12 12s5.365 12 12 12c6.926 0 11.52-4.869 11.52-11.726 0-.788-.085-1.39-.189-1.989H12.24z"/>
        </svg>
        <span>{loading ? 'Connexion en cours...' : text}</span>
      </button>
      <AuthErrorMessage 
        error={errorMessage} 
        errorCode={errorCode} 
        onClose={() => {
          resetAuthError();
          setLocalError(null);
          setErrorCode(undefined);
        }}
      />
    </div>
  );
};

export default GoogleSignInButton;
